import _isEmpty from 'lodash-es/isEmpty';
import _has from 'lodash-es/has';
import _keyBy from 'lodash-es/keyBy';

import {createSelector} from 'reselect';

import RootState from 'Store/Root';

import {BasketItemList, BasketItemColorway, BasketItemRug} from 'Types/Basket';

import {
  colorwayItemsSelector,
  hasColorwaysLoadedSelector
} from './Colorways';
import {
  rugItemsSelector,
  hasRugsLoadedSelector
} from './Rugs';
import {AnalyticsInfo} from 'Types/Designs';

export const basketItemCountSelector = createSelector(
  (state: RootState) => state.basket.itemsList,
  (list: string[]): number => list.length
);

export const basketItemsSelector = createSelector(
  (state: RootState) => state.basket.itemsList,
  colorwayItemsSelector,
  rugItemsSelector,
  (list: string[], colorways, rugs): BasketItemList => {
    if (_isEmpty(list) || list.length !== colorways.length + rugs.length) {
      return [];
    }

    const colorwayKeys = _keyBy(colorways, x => x.id);
    const rugKeys = _keyBy(rugs, x => x.id);
    const items = list.map(x => {
      if (_has(colorwayKeys, x)) {
        return colorwayKeys[x];
      } else if (_has(rugKeys, x)) {
        return rugKeys[x];
      } else {
        console.log(`Unable to find Basket ID ${x}.`);
        return null;
      }
    });

    const result = items.filter(x => !_isEmpty(x));

    return result;
  }
);

export const basketItemsAnalyticsSelector = createSelector(
  (state: RootState) => state.designs.itemsByCode,
  basketItemsSelector,
  (designState, items): AnalyticsInfo[] => {

    let products: AnalyticsInfo[] = [];

    for (const index in items) {
      let analytics: AnalyticsInfo;
      const basketItemColorway = items[index] as BasketItemColorway;
      if (typeof basketItemColorway.colorway !== 'undefined') {
        analytics = {
          id: basketItemColorway.colorway.designCode,
          name: basketItemColorway.colorway.designName,
          brand: basketItemColorway.brand.name,
          category: 'Carpet',
          variant: basketItemColorway.colorway.colorName,
          price: '1.00',
          quantity: 1,
          dimension6: basketItemColorway.product.hasRoom ? 'room' : 'swatch',
        };
        products.push(analytics);
        continue;
      }

      const basketItemRug = items[index] as BasketItemRug;
      if (typeof basketItemRug.rug !== 'undefined') {
        for (const rugIndex in basketItemRug.rug.components) {
          const designCode = basketItemRug.rug.components[rugIndex].designCode;
          const design = designState[designCode.toUpperCase()];
          analytics = {
            id: design.overview.code,
            name: design.overview.name,
            brand: design.overview.brandName,
            category: 'Carpet',
            variant: 'undefined',
            price: '1.00',
            quantity: 1,
            dimension6: basketItemRug.product.hasRoom ? 'room' : 'swatch',
          };
          products.push(analytics);
        }
      }

      return products;
    }
  }
);

export const hasLoadedSelector = createSelector(
  hasColorwaysLoadedSelector,
  hasRugsLoadedSelector,
  (colorwaysLoaded, rugsLoaded): boolean => {
    return colorwaysLoaded && rugsLoaded;
  }
);
